import React, { FC } from 'react'
import { AllSystemProps } from '@moonpig/launchpad-system'
import { SellingPointsContent } from '../../components/SellingPoints'
import { useProductStore } from '../../contexts/product'
import { type ModuleSellingPoints, type ModuleContext } from '../types'

type Props = {
  module: ModuleSellingPoints
  context: ModuleContext
} & AllSystemProps

export const SellingPointsModule: FC<Props> = ({ ...props }) => {
  const [{ product }] = useProductStore()

  return <SellingPointsContent product={product} {...props} />
}
